import clsx from "clsx";
import PropTypes, { InferProps } from "prop-types";
import React, { ReactElement } from "react";

import { Container, Typography } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

import PreviewCompatibleImage from "../PreviewCompatibleImage";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      alignContent: "center",
      alignItems: "center",
      display: "grid",
      width: "100%",
      [theme.breakpoints.down("sm")]: {
        marginBottom: theme.spacing(8)
      },
      [theme.breakpoints.up("sm")]: {
        gridTemplateColumns: "1fr 1fr",
        "&.orientation-rtl": {
          "& $about": {
            order: "-1"
          }
        }
      }
    },
    about: {},
    headshot: {
      [theme.breakpoints.down("sm")]: {
        marginBottom: theme.spacing(2)
      }
    },
    media: {
      height: 0,
      paddingTop: "56.25%" // 16:9
    }
  })
);

export const Member = ({
  member,
  orientation = "ltr"
}: InferProps<typeof Member.propTypes> = {}): ReactElement => {
  const classes = useStyles();

  return (
    <article className={clsx(classes.root, `orientation-${orientation}`)}>
      <section className={classes.headshot}>
        {member.featuredimage ? (
          <PreviewCompatibleImage
            imageInfo={{
              image: member.featuredimage,
              alt: `Headshot image for ${member.name}`,
              style: {
                minHeight: "50vh"
              }
            }}
          />
        ) : null}
      </section>
      <Container
        component="section"
        className={clsx(classes.about)}
        maxWidth="sm"
      >
        <Typography variant="h5" component="h1" gutterBottom>
          {member.title}
        </Typography>
        <Typography variant="h3" component="h2" gutterBottom>
          {member.name}
        </Typography>
        <Typography component="div" gutterBottom>
          {member.paragraphs}
        </Typography>
      </Container>
    </article>
  );
};

Member.propTypes = { member: PropTypes.object };

export default Member;
